// import React from 'react';
// import { NavLink } from 'react-router-dom';
// import { ChevronRight, LayoutDashboard, Home, FileText, Users, ShoppingBag, Settings, FileSearch, List, MessageSquare, BookOpenCheck, Library, Newspaper, Grid, Globe, Database, Siren, KanbanSquare, ClipboardList, Layers, FolderOpen, Tag, Youtube, KeyRound, Hash, Users as UsersIcon, HelpCircle, Megaphone, Search, Slack, User, BookOpen, CheckSquare, PenSquare, Square, Phone, Send, Play, Cog, CheckSquare as CheckSquareIcon } from 'lucide-react';
// import clsx from 'clsx';

// interface SidebarProps {
//   open?: boolean;
//   onClose?: () => void;
// }

// interface MenuItem {
//   to?: string;
//   icon: React.ReactNode;
//   label: string;
//   children?: MenuItem[];
// }

// const SectionTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
//   <div className="px-4 pt-6 pb-2 text-xs font-semibold uppercase tracking-wider text-gray-500 font-medium">{children}</div>
// );

// const SubMenuItem: React.FC<{ item: MenuItem; isActive?: boolean }> = ({ item, isActive }) => {
//   if (item.to) {
//     return (
//       <NavLink
//         to={item.to}
//         className={({ isActive }) => clsx(
//           'block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md transition-colors',
//           (isActive || isActive) && 'text-green-600'
//         )}
//       >
//         <div className="flex items-center gap-3">
//           <div className={clsx(
//             'w-2 h-2 rounded-full',
//             (isActive || isActive) ? 'bg-green-600' : 'bg-gray-100'
//           )} />
//           <span>{item.label}</span>
//         </div>
//       </NavLink>
//     );
//   }

//   return (
//     <div className="px-4 py-2 text-sm text-gray-500">
//       <div className="flex items-center gap-3">
//         <div className="w-2 h-2 rounded-full bg-gray-400" />
//         <span>{item.label}</span>
//       </div>
//     </div>
//   );
// };

// const MenuItem: React.FC<{ item: MenuItem; isActive?: boolean }> = ({ item, isActive }) => {
//   const [isExpanded, setIsExpanded] = React.useState(false);

//   const hasChildren = item.children && item.children.length > 0;

//   if (hasChildren) {
//     return (
//       <li
//         className={clsx(isExpanded && 'is-expanded')}
//       >
//         <button
//           onClick={() => setIsExpanded(!isExpanded)}
//           className={clsx(
//             'w-full flex items-center justify-between px-4 py-3 text-sm text-gray-800 rounded-md transition-colors',
//             isActive && 'bg-green-600 text-white'
//           )}
//         >
//           <div className="flex items-center gap-3">
//             <span className="shrink-0 h-4 w-4">{item.icon}</span>
//             <span className="font-medium">{item.label}</span>
//           </div>
//           <ChevronRight
//             className={clsx(
//               'h-4 w-4 text-gray-400 transition-transform duration-200',
//               isExpanded && 'rotate-90',
//               isActive && 'text-white'
//             )}
//           />
//         </button>

//         {isExpanded && (
//           <ul className="slide-menu open mt-1" style={{ display: 'block' }}>
//             <li className="panel sidetab-menu">
//               <div className="panel-body tabs-menu-body p-0 border-0">
//                 <div className="tab-content">
//                   <div className="tab-pane active">
//                     <ul className="sidemenu-list space-y-1 ml-4">
//                       {item.children?.map((child, index) => (
//                         <li key={index} className={clsx(child.to === '/dashboard' && 'active')}>
//                           <SubMenuItem item={child} isActive={child.to === '/dashboard'} />
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </li>
//           </ul>
//         )}
//       </li>
//     );
//   }

//   return (
//     <li>
//       <NavLink
//         to={item.to || '#'}
//         className={({ isActive: navIsActive }) => clsx(
//           'block flex items-center gap-3 px-4 py-3 text-sm text-gray-800 rounded-md transition-colors',
//           (isActive) && 'bg-green-600'
//         )}
//       >
//         <span className="shrink-0 h-4 w-4">{item.icon}</span>
//         <span className="font-medium">{item.label}</span>
//         <ChevronRight className="h-4 w-4 text-gray-400 ml-auto" />
//       </NavLink>
//     </li>
//   );
// };

// const Sidebar: React.FC<SidebarProps> = ({ open }) => {
//   const menuItems: MenuItem[] = [
//     {
//       icon: <Home className="h-4 w-4" />,
//       label: 'Dashboards',
//       children: [
//         { to: '/dashboard', label: 'Web Dashboards', icon: <div className="w-2 h-2 rounded-full bg-green-500" /> },
//         { to: '#', label: 'CRM (Upcoming)', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Marketing (Upcoming)', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
// {
//   to: '#',
//   icon: <Slack className="h-4 w-4" />,
//   label: 'Home',
//   children: [
//     { to: '/slider', label: 'Slider', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//     { to: '/content', label: 'Content', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//     // { to: '/content', label: 'Content Feature', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//     { to: '/youtube-channels', label: 'Youtube Channels', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//     { to: '/youtube-videos', label: 'Youtube Videos', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//     { to: '/our-faculty', label: 'Our Faculty ', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//     { to: '/testimonial', label: 'Testimonial', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//   ]
// },
//     {
//       to: '#',
//       icon: <User className="h-4 w-4" />,
//       label: 'Seminar',
//       children: [
//         // { to: '#', label: 'Seminar', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Seminar Details', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Seminar Slider', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Seminar Users', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <Users className="h-4 w-4" />,
//       label: 'About Us',
//       children: [
//         // { to: '#', label: 'About Us', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'About Details', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <Users className="h-4 w-4" />,
//       label: 'Contact Us',
//       children: [
//         // { to: '#', label: 'Contact Us', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Contact Details', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Contact Enquiry', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Callback Enquiry', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <HelpCircle className="h-4 w-4" />,
//       label: 'Common Sections',
//       children: [
//         // { to: '#', label: 'Common Sections', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Category', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Sub Category', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Footer', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Header', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'SEO', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <Megaphone className="h-4 w-4" />,
//       label: 'Internal Ads',
//       children: [
//         // { to: '#', label: 'Internal Ads', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Internal Ads', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <Search className="h-4 w-4" />,
//       label: 'Explore',
//       children: [
//         // { to: '#', label: 'Explore', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Ad Post', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'All Post', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Category', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Tags', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <Square className="h-4 w-4" />,
//       label: 'Previous Papers',
//       children: [
//         // { to: '#', label: 'Previous Papers', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'All Previous Papers', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Add Previous Papers', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <Square className="h-4 w-4" />,
//       label: 'Doubt Engine',
//       children: [
//         // { to: '#', label: 'Doubt Engine', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'All Doubts', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Add Doubt', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
// {
//   to: '#',
//   icon: <ShoppingBag className="h-4 w-4" />,
//   label: 'Ecommerce',
//   children: [
//     // { to: '#', label: 'Ecommerce', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//     { to: '#', label: 'Add Product', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//     { to: '#', label: 'Products', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//     { to: '#', label: 'Product List', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//     { to: '#', label: 'Wishlist', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//     { to: '#', label: 'Order Lists', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//     { to: '#', label: 'Pending Order', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//   ]
// },
//     {
//       to: '#',
//       icon: <BookOpen className="h-4 w-4" />,
//       label: 'Courses',
//       children: [
//         // { to: '#', label: 'Courses', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'All Courses', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Add Course', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <CheckSquare className="h-4 w-4" />,
//       label: 'Test Series',
//       children: [
//         // { to: '#', label: 'Test Series', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'All Test Series', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Add Test Series', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <HelpCircle className="h-4 w-4" />,
//       label: 'Quiz',
//       children: [
//         // { to: '#', label: 'Quiz', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'All Quiz', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Add Quiz', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Student Score', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <PenSquare className="h-4 w-4" />,
//       label: 'E-Notes',
//       children: [
//         // { to: '#', label: 'E-Notes', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'All E-Notes', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Add E-Notes', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <BookOpen className="h-4 w-4" />,
//       label: 'Exams',
//       children: [
//         // { to: '#', label: 'Exams', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Add Exams', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'All Exams', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <Square className="h-4 w-4" />,
//       label: 'Blogs',
//       children: [
//         // { to: '#', label: 'Blogs', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'All Article', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Add Article', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Category', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Tags', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <Phone className="h-4 w-4" />,
//       label: 'Web Stories',
//       children: [
//         // { to: '#', label: 'Web Stories', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'All Web Stories', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Add Web Stories', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <Send className="h-4 w-4" />,
//       label: 'SMS Panel',
//       children: [
//         // { to: '#', label: 'SMS Panel', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Delivery History', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Credit History', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <Play className="h-4 w-4" />,
//       label: 'Youtube Management',
//       children: [
//         // { to: '#', label: 'Youtube Management', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Youtube Channels', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Add Video', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'List Video', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Playlists', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Categories', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Tags', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Keywords Research', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <CheckSquareIcon className="h-4 w-4" />,
//       label: 'Content Market(Upcoming)',
//       children: [
//         // { to: '#', label: 'Content Market', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Content Market', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Test Series', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'PDF & Notes', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Current Affairs', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Magazines', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     },
//     {
//       to: '#',
//       icon: <Cog className="h-4 w-4" />,
//       label: 'Settings',
//       children: [
//         // { to: '#', label: 'Settings', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Admins', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Users', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Website Traffic', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
//         { to: '#', label: 'Software Version 1.0.1', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
//       ]
//     }
//   ];

//   return (
//     <aside className={clsx(
//       'fixed lg:static inset-y-0 left-0 z-40 w-72 shrink-0 transform border-r border-gray-200 bg-white transition-transform duration-200',
//       open ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
//     )}>
//       <nav className="overflow-y-auto h-full pb-6">
//         <SectionTitle>Main</SectionTitle>
//         <div className="px-2 space-y-1">
//           <MenuItem item={menuItems[0]} isActive={true} />
//         </div>

//         <SectionTitle>Premade Pages</SectionTitle>
//         <div className="px-2 space-y-1">
//           {menuItems.slice(1, 7).map((item, index) => (
//             <MenuItem key={index} item={item} />
//           ))}
//         </div>

//         <SectionTitle>Explore/Feed</SectionTitle>
//         <div className="px-2 space-y-1">
//           <MenuItem item={menuItems[7]} />
//         </div>

//         <SectionTitle>PYQ Engine</SectionTitle>
//         <div className="px-2 space-y-1">
//           <MenuItem item={menuItems[8]} />
//         </div>

//         <SectionTitle>Doubt Engine</SectionTitle>
//         <div className="px-2 space-y-1">
//           <MenuItem item={menuItems[9]} />
//         </div>

//         <SectionTitle>Ecommerce/Publication</SectionTitle>
//         <div className="px-2 space-y-1">
//           <MenuItem item={menuItems[10]} />
//         </div>

//         <SectionTitle>Offerings</SectionTitle>
//         <div className="px-2 space-y-1">
//           {menuItems.slice(11, 16).map((item, index) => (
//             <MenuItem key={index} item={item} />
//           ))}
//         </div>

//         <SectionTitle>Blogs/News</SectionTitle>
//         <div className="px-2 space-y-1">
//           <MenuItem item={menuItems[16]} />
//         </div>

//         <SectionTitle>Web Stories</SectionTitle>
//         <div className="px-2 space-y-1">
//           <MenuItem item={menuItems[17]} />
//         </div>

//         <SectionTitle>SMS Panel</SectionTitle>
//         <div className="px-2 space-y-1">
//           <MenuItem item={menuItems[18]} />
//         </div>

//         <SectionTitle>Youtube</SectionTitle>
//         <div className="px-2 space-y-1">
//           <MenuItem item={menuItems[19]} />
//         </div>

//         <SectionTitle>Content Market</SectionTitle>
//         <div className="px-2 space-y-1">
//           <MenuItem item={menuItems[20]} />
//         </div>

//         <SectionTitle>Website Setting</SectionTitle>
//         <div className="px-2 space-y-1 mb-8">
//           <MenuItem item={menuItems[21]} />
//         </div>
//       </nav>
//     </aside>
//   );
// };

// export default Sidebar;


import React from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronRight, Home, Users, HelpCircle, Square, BookOpen, ShoppingBag, Settings } from 'lucide-react';
import clsx from 'clsx';

interface SidebarProps {
  open?: boolean;
  onClose?: () => void;
}

interface MenuItem {
  to?: string;
  icon: React.ReactNode;
  label: string;
  children?: MenuItem[];
}

const SectionTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="px-4 pt-6 pb-2 text-xs font-semibold uppercase tracking-wider text-gray-500 font-medium">
    {children}
  </div>
);

const SubMenuItem: React.FC<{ item: MenuItem; isActive?: boolean }> = ({ item, isActive }) => {
  if (item.to) {
    return (
      <NavLink
        to={item.to}
        className={({ isActive }) =>
          clsx(
            'block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md transition-colors',
            (isActive || isActive) && 'text-green-600'
          )
        }
      >
        <div className="flex items-center gap-3">
          <div className={clsx('w-2 h-2 rounded-full', (isActive || isActive) ? 'bg-green-600' : 'bg-gray-100')} />
          <span>{item.label}</span>
        </div>
      </NavLink>
    );
  }

  return (
    <div className="px-4 py-2 text-sm text-gray-500">
      <div className="flex items-center gap-3">
        <div className="w-2 h-2 rounded-full bg-gray-400" />
        <span>{item.label}</span>
      </div>
    </div>
  );
};

const MenuItem: React.FC<{ item: MenuItem; isActive?: boolean }> = ({ item, isActive }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const hasChildren = item.children && item.children.length > 0;

  if (hasChildren) {
    return (
      <li className={clsx(isExpanded && 'is-expanded')}>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={clsx(
            'w-full flex items-center justify-between px-4 py-3 text-sm text-gray-800 rounded-md transition-colors',
            isActive && 'bg-green-600 text-white'
          )}
        >
          <div className="flex items-center gap-3">
            <span className="shrink-0 h-4 w-4">{item.icon}</span>
            <span className="font-medium">{item.label}</span>
          </div>
          <ChevronRight
            className={clsx(
              'h-4 w-4 text-gray-400 transition-transform duration-200',
              isExpanded && 'rotate-90',
              isActive && 'text-white'
            )}
          />
        </button>

        {isExpanded && (
          <ul className="ml-4 mt-1 space-y-1">
            {item.children?.map((child, index) => (
              <li key={index}>
                <SubMenuItem item={child} />
              </li>
            ))}
          </ul>
        )}
      </li>
    );
  }

  return (
    <li>
      <NavLink
        to={item.to || '#'}
        className={({ isActive: navIsActive }) =>
          clsx(
            'block flex items-center gap-3 px-4 py-3 text-sm text-gray-800 rounded-md transition-colors',
            navIsActive && 'bg-green-600 text-white'
          )
        }
      >
        <span className="shrink-0 h-4 w-4">{item.icon}</span>
        <span className="font-medium">{item.label}</span>
        <ChevronRight className="h-4 w-4 text-gray-400 ml-auto" />
      </NavLink>
    </li>
  );
};

const Sidebar: React.FC<SidebarProps> = ({ open }) => {
  const menuItems: MenuItem[] = [
    {
      icon: <Home className="h-4 w-4" />,
      label: 'Dashboard',
      children: [
        { to: '/dashboard', label: 'Web Dashboards', icon: <div className="w-2 h-2 rounded-full bg-green-500" /> }
      ]
    },
    {
      to: '#',
      icon: <Square className="h-4 w-4" />,
      label: 'Home',
      children: [
        { to: '/slider', label: 'Slider', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/content', label: 'Content', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        // { to: '/content', label: 'Content Feature', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/youtube-channels', label: 'Youtube Channels', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/youtube-videos', label: 'Youtube Videos', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/our-faculty', label: 'Our Faculty ', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        // { to: '/testimonial', label: 'Testimonial', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
      ]
    },
    {
      icon: <Users className="h-4 w-4" />,
      label: 'About Us',
      children: [
        { to: '/about-details', label: 'About Details', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
      ]
    },
    {
      icon: <HelpCircle className="h-4 w-4" />,
      label: 'Contact Us',
      children: [
        { to: '/contact-details', label: 'Contact Details', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/contact-enquiry', label: 'Contact Enquiry', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/callback-enquiry', label: 'Callback Enquiry', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
      ]
    },
    {
      icon: <Settings className="h-4 w-4" />,
      label: 'Settings',
      children: [
        { to: '/settings/category', label: 'Category', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/settings/sub-category', label: 'Sub Category', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/settings/footer', label: 'Footer', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/settings/header', label: 'Header', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/settings/seo', label: 'SEO', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }

      ]
    },
    {
      to: '#',
      icon: <ShoppingBag className="h-4 w-4" />,
      label: 'Ecommerce',
      children: [
        // { to: '#', label: 'Ecommerce', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/products/add', label: 'Add Product', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        // { to: '/products', label: 'Products', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/products/list', label: 'Product List', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        // { to: '#', label: 'Wishlist', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        // { to: '#', label: 'Order Lists', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        // { to: '#', label: 'Pending Order', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
      ]
    },
    // {
    //   to: '#',
    //   icon: <ShoppingBag className="h-4 w-4" />,
    //   label: 'Courses',
    //   children: [
    //     // { to: '#', label: 'Ecommerce', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
    //     { to: '/courses/add', label: 'Add Course', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
    //     // { to: '/products', label: 'Products', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
    //     { to: '/courses/list', label: 'Course List', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
    //     // { to: '#', label: 'Wishlist', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
    //     // { to: '#', label: 'Order Lists', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
    //     // { to: '#', label: 'Pending Order', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
    //   ]
    // },
    {
      icon: <Square className="h-4 w-4" />,
      label: 'Blogs',
      children: [
        { to: '/blogs', label: 'All Article', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/blogs/add', label: 'Add Article', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/blogs/categories', label: 'Category', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/blogs/tags', label: 'Tags', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
      ]
    },
    {
      icon: <BookOpen className="h-4 w-4" />,
      label: 'Course',
      children: [
        { to: '/courses', label: 'All Courses', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/courses/add', label: 'Add Course', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
      ]
    },
    {
      icon: <BookOpen className="h-4 w-4" />,
      label: 'Books',
      children: [
        { to: '/books', label: 'All Books', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> },
        { to: '/books/add', label: 'Add Book', icon: <div className="w-2 h-2 rounded-full bg-gray-400" /> }
      ]
    }
  ];

  return (
    <aside
      className={clsx(
        'fixed lg:static inset-y-0 left-0 z-40 w-72 shrink-0 transform border-r border-gray-200 bg-white transition-transform duration-200',
        open ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
      )}
    >
      <nav className="overflow-y-auto h-full pb-6">
        <SectionTitle>Main</SectionTitle>
        <div className="px-2 space-y-1">
          <MenuItem item={menuItems[0]} />
        </div>

        <SectionTitle>Premade Pages</SectionTitle>
        <div className="px-2 space-y-1">
          <MenuItem item={menuItems[1]} />
          <MenuItem item={menuItems[2]} />
          <MenuItem item={menuItems[3]} />
          <MenuItem item={menuItems[4]} />
          <MenuItem item={menuItems[6]} />
          <MenuItem item={menuItems[7]} />
          <MenuItem item={menuItems[8]} />
          {/* <MenuItem item={menuItems[9]} /> */}

        </div>

        {/* <SectionTitle>About Us</SectionTitle>
        <div className="px-2 space-y-1">
          <MenuItem item={menuItems[2]} />
        </div> */}

        {/* <SectionTitle>Contact Us</SectionTitle>
        <div className="px-2 space-y-1">
          <MenuItem item={menuItems[3]} />
        </div> 

        <SectionTitle>Blogs</SectionTitle>
        <div className="px-2 space-y-1 mb-8">
          <MenuItem item={menuItems[4]} />
        </div>

        <SectionTitle>Courses</SectionTitle>
        <div className="px-2 space-y-1 mb-8">
          <MenuItem item={menuItems[5]} />
        </div>*/}
      </nav>
    </aside>
  );
};

export default Sidebar; 
